function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.25 13.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm6 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm4-10.5a.75.75 0 010 1.5H14.9a.25.25 0 00-.25.223l-.777 7.255a1.769 1.769 0 01-1.735 1.522H6.082a1.747 1.747 0 01-1.66-1.2l-1.333-4A1.75 1.75 0 014.749 6h8.03a.251.251 0 00.25-.223l.177-1.66A1.249 1.249 0 0114.449 3z",
  fill: "#545454",
  fillRule: "evenodd"
})));